import { showErrorResponse } from "../../app/utils/common/Functions";
import { showSuccessToast } from "../../app/utils/common/Toast";
import {
  createMachineUserAPI,
  createAttendanceHolidayAPI,
  deleteAttendanceHolidayAPI,
  deleteMachineUserAPI,
  getAttendanceCalendarAPI,
  getAttendanceConfigAPI,
  getAttendanceDailyAnalyticsAPI,
  getAttendanceHolidaysAPI,
  getAttendanceLogsAPI,
  getAttendanceTeamWeekAPI,
  getDashboardTodayAttendanceAPI,
  getDashboardYesterdayAttendanceAPI,
  getMachineUsersAPI,
  getAttendanceWebhookStatusAPI,
  putAttendanceDayOverrideAPI,
  syncDashboardUserToMachineAPI,
  syncAttendanceAPI,
  updateMachineUserAPI,
  updateAttendanceConfigAPI,
} from "../Apis/attendanceApi";

export const attendanceReducer = (builder) => {
  builder
    .addCase(getAttendanceCalendarAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(getAttendanceCalendarAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.calendar = action.payload.data || {};
    })
    .addCase(getAttendanceCalendarAPI.rejected, (state, action) => {
      state.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(syncAttendanceAPI.pending, (state) => {
      state.syncing = true;
    })
    .addCase(syncAttendanceAPI.fulfilled, (state) => {
      state.syncing = false;
      state.lastSyncAt = Date.now();
      showSuccessToast("Attendance synced successfully.");
    })
    .addCase(syncAttendanceAPI.rejected, (state, action) => {
      state.syncing = false;
      showErrorResponse(action.payload);
    })
    .addCase(getDashboardTodayAttendanceAPI.pending, (state) => {
      state.dashboardTodayLogsLoading = true;
    })
    .addCase(getDashboardTodayAttendanceAPI.fulfilled, (state, action) => {
      state.dashboardTodayLogsLoading = false;
      state.dashboardTodayLogs = action.payload?.data?.logs || [];
    })
    .addCase(getDashboardTodayAttendanceAPI.rejected, (state) => {
      state.dashboardTodayLogsLoading = false;
      state.dashboardTodayLogs = [];
    })
    .addCase(getDashboardYesterdayAttendanceAPI.pending, (state) => {
      state.dashboardYesterdayLogsLoading = true;
    })
    .addCase(getDashboardYesterdayAttendanceAPI.fulfilled, (state, action) => {
      state.dashboardYesterdayLogsLoading = false;
      state.dashboardYesterdayLogs = action.payload?.data?.logs || [];
    })
    .addCase(getDashboardYesterdayAttendanceAPI.rejected, (state) => {
      state.dashboardYesterdayLogsLoading = false;
      state.dashboardYesterdayLogs = [];
    })
    .addCase(getAttendanceLogsAPI.pending, (state) => {
      state.logsLoading = true;
    })
    .addCase(getAttendanceLogsAPI.fulfilled, (state, action) => {
      state.logsLoading = false;
      state.logs = action.payload?.data?.logs || [];
      state.logsPagination = action.payload?.data?.pagination || { page: 1, limit: 50, total: 0 };
    })
    .addCase(getAttendanceLogsAPI.rejected, (state, action) => {
      state.logsLoading = false;
      showErrorResponse(action.payload);
    })
    .addCase(getMachineUsersAPI.pending, (state) => {
      state.machineUsersLoading = true;
    })
    .addCase(getMachineUsersAPI.fulfilled, (state, action) => {
      state.machineUsersLoading = false;
      state.machineUsers = action.payload?.data || [];
    })
    .addCase(getMachineUsersAPI.rejected, (state, action) => {
      state.machineUsersLoading = false;
      const message =
        action?.payload?.message ||
        action?.payload?.error?.message ||
        "";
      if (String(message).includes("not configured for this device profile")) {
        state.machineUsers = [];
        return;
      }
      showErrorResponse(action.payload);
    })
    .addCase(createMachineUserAPI.pending, (state) => {
      state.machineUsersMutating = true;
    })
    .addCase(createMachineUserAPI.fulfilled, (state) => {
      state.machineUsersMutating = false;
      showSuccessToast("Machine user created.");
    })
    .addCase(createMachineUserAPI.rejected, (state, action) => {
      state.machineUsersMutating = false;
      showErrorResponse(action.payload);
    })
    .addCase(updateMachineUserAPI.pending, (state) => {
      state.machineUsersMutating = true;
    })
    .addCase(updateMachineUserAPI.fulfilled, (state) => {
      state.machineUsersMutating = false;
      showSuccessToast("Machine user updated.");
    })
    .addCase(updateMachineUserAPI.rejected, (state, action) => {
      state.machineUsersMutating = false;
      showErrorResponse(action.payload);
    })
    .addCase(deleteMachineUserAPI.pending, (state) => {
      state.machineUsersMutating = true;
    })
    .addCase(deleteMachineUserAPI.fulfilled, (state) => {
      state.machineUsersMutating = false;
      showSuccessToast("Machine user deleted.");
    })
    .addCase(deleteMachineUserAPI.rejected, (state, action) => {
      state.machineUsersMutating = false;
      showErrorResponse(action.payload);
    })
    .addCase(syncDashboardUserToMachineAPI.pending, (state) => {
      state.machineUsersMutating = true;
    })
    .addCase(syncDashboardUserToMachineAPI.fulfilled, (state) => {
      state.machineUsersMutating = false;
      showSuccessToast("Dashboard user synced to machine.");
    })
    .addCase(syncDashboardUserToMachineAPI.rejected, (state, action) => {
      state.machineUsersMutating = false;
      showErrorResponse(action.payload);
    })
    .addCase(getAttendanceConfigAPI.fulfilled, (state, action) => {
      state.config = action.payload.data || null;
    })
    .addCase(getAttendanceConfigAPI.rejected, (_state, action) => {
      showErrorResponse(action.payload);
    })
    .addCase(getAttendanceWebhookStatusAPI.fulfilled, (state, action) => {
      state.webhookStatus = action.payload.data || null;
    })
    .addCase(getAttendanceWebhookStatusAPI.rejected, (_state, action) => {
      showErrorResponse(action.payload);
    })
    .addCase(updateAttendanceConfigAPI.pending, (state) => {
      state.savingConfig = true;
    })
    .addCase(updateAttendanceConfigAPI.fulfilled, (state) => {
      state.savingConfig = false;
      showSuccessToast("Attendance configuration updated.");
    })
    .addCase(updateAttendanceConfigAPI.rejected, (state, action) => {
      state.savingConfig = false;
      showErrorResponse(action.payload);
    })
    .addCase(getAttendanceDailyAnalyticsAPI.pending, (state) => {
      state.analyticsLoading = true;
    })
    .addCase(getAttendanceDailyAnalyticsAPI.fulfilled, (state, action) => {
      state.analyticsLoading = false;
      const data = action.payload?.data || null;
      const view = action.meta?.arg?.view || "overview";
      if (view === "history") state.analyticsHistory = data;
      else state.analyticsOverview = data;
    })
    .addCase(getAttendanceDailyAnalyticsAPI.rejected, (state, action) => {
      state.analyticsLoading = false;
      showErrorResponse(action.payload);
    })
    .addCase(getAttendanceTeamWeekAPI.pending, (state) => {
      state.teamWeekLoading = true;
    })
    .addCase(getAttendanceTeamWeekAPI.fulfilled, (state, action) => {
      state.teamWeekLoading = false;
      state.teamWeek = action.payload?.data || null;
    })
    .addCase(getAttendanceTeamWeekAPI.rejected, (state, action) => {
      state.teamWeekLoading = false;
      showErrorResponse(action.payload);
    })
    .addCase(getAttendanceHolidaysAPI.pending, (state) => {
      state.holidaysLoading = true;
    })
    .addCase(getAttendanceHolidaysAPI.fulfilled, (state, action) => {
      state.holidaysLoading = false;
      state.holidaysList = action.payload?.data || [];
    })
    .addCase(getAttendanceHolidaysAPI.rejected, (state, action) => {
      state.holidaysLoading = false;
      showErrorResponse(action.payload);
    })
    .addCase(createAttendanceHolidayAPI.fulfilled, (state, action) => {
      showSuccessToast(action.payload?.message || "Holiday added.");
    })
    .addCase(createAttendanceHolidayAPI.rejected, (_state, action) => {
      showErrorResponse(action.payload);
    })
    .addCase(deleteAttendanceHolidayAPI.fulfilled, (state, action) => {
      showSuccessToast(action.payload?.message || "Holiday removed.");
    })
    .addCase(deleteAttendanceHolidayAPI.rejected, (_state, action) => {
      showErrorResponse(action.payload);
    })
    .addCase(putAttendanceDayOverrideAPI.fulfilled, (state, action) => {
      showSuccessToast(action.payload?.message || "Day updated.");
    })
    .addCase(putAttendanceDayOverrideAPI.rejected, (_state, action) => {
      showErrorResponse(action.payload);
    });
};
